import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {SharedStateService} from "../../core/services/shared-state.service";

export const customerHasCurrentLoanGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  const sharedState = inject(SharedStateService);

  let result = true;

  if (route.data["customerHasCurrentLoan"]) {
    if (!sharedState.customerCurrentLoan()?.customerPin) {
      router.navigateByUrl("/");
      result = false;
    } else {
      result = true;
    }
  } else {
    if (sharedState.customerCurrentLoan()?.customerPin) {
      router.navigateByUrl("/customer/profile");
      result = false;
    } else {
      result = true;
    }
  }

  return result;
};
